import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f49f584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process bi__block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.yxvzb.com/WEB/SaaS/bi-v3/images/1.jpg",
  alt: ""
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-process-1',
  setup(__props) {

// import { getProcessData } from './index';
// const data = getProcessData().reduce(
//   (pre, cur) => {
//     const last = pre.slice(-1)[0];
//     if (Array.isArray(last) && last?.length < 3) {
//       last.push(cur);
//     } else {
//       pre.push([cur]);
//     }
//     return pre;
//   },
//   [[]] as Array<Array<string>>
// );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})